import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sort: "",
    filter: "all",
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        blogSorted: (state, action) => {
            state.sort = action.payload;
        },
        blogFiltered: (state, action) => {
            state.filter = action.payload;
        },
    },
});

export default filterSlice.reducer;
export const { blogSorted, blogFiltered } = filterSlice.actions;
